import DialogContent from "@mui/material/DialogContent";
import React, { useCallback, useState } from "react";
import { Form as FinalForm } from "react-final-form";
import * as S from "../../constants/StringConstants";
import PromptModal from "../ConfirmationModal/PromptModalV2";
import CustomDropzone from "../Form/Dropzone/Dropzone";
import "./UploadDocumentModalV2.scss";

export interface UploadDocumentModalProps {
  accept?: string;
  open: boolean;
  handleFiles: <T extends File>(acceptedFiles: T[]) => void;
  onCancel: () => void;
}

const UploadDocumentModal: React.FC<UploadDocumentModalProps> = ({ accept, open, handleFiles, onCancel }) => {
  const [files, setFiles] = useState<File[]>([]);

  const handleDrop = useCallback((acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0) {
      setFiles(prev => [...prev, ...acceptedFiles]);
    }
  }, []);

  const handleClickCancel = () => {
    onCancel();
    setFiles([]);
  };

  const handleClickUpload = () => {
    handleFiles(files);
    setFiles([]);
    onCancel();
  };

  const handleDeleteFile = (index: number) => {
    setFiles(prev => prev.filter((_, idx) => idx !== index));
  };

  return (
    <PromptModal
      open={open}
      title={S.UDM_TITLE}
      confirmText={S.UDM_UPLOAD_BUTTON}
      rejectText={S.UDM_CANCEL_BUTTON}
      onConfirm={handleClickUpload}
      onReject={handleClickCancel}
      width="60rem">
      <div>
        <FinalForm onSubmit={handleClickUpload} initialValues={{}}>
          {formProps => (
            <form onSubmit={formProps.handleSubmit}>
              <h4 className="upload-modal-v2__secondary-title">{S.UDM_UPLOAD_FILES}</h4>
              <DialogContent sx={{ p: "0" }}>
                <CustomDropzone
                  files={files}
                  onDrop={handleDrop}
                  onRemove={handleDeleteFile}
                  multiple={true}
                  placeholder={S.UDM_DROPZONE}
                />

                {formProps.error && formProps.dirty && <div className="dropzone__error">{formProps.error}</div>}
              </DialogContent>
            </form>
          )}
        </FinalForm>
      </div>
    </PromptModal>
  );
};

export default UploadDocumentModal;
